import { __, n__ } from "bits/intl"
import t from "vuedirectives/t"

export default {
  directives: { t },
  filters: {
    __: __
  },
  methods: {
    __: __,
    n__: n__
  }
}